import { ref, Ref, nextTick, watch } from 'vue'

/** 商品子表普通订单默认分页条数。 */
const DEFAULT_CHILD_PAGE_LIMIT = 10

/** 商品子表智能补货订单默认分页条数。 */
const REPLENISH_CHILD_PAGE_LIMIT = 9999

/** 判断订单是否为智能补货订单。 */
const isReplenishOrder = (row: any) => {
  return row?.tags?.includes(7)
}

/** 根据订单数据创建商品子表分页初始值。 */
const createChildPageData = (row: any) => {
  return {
    page: 1,
    limit: isReplenishOrder(row) ? REPLENISH_CHILD_PAGE_LIMIT : DEFAULT_CHILD_PAGE_LIMIT
  }
}

/** 初始化单条订单的商品子表分页参数。 */
const resetChildPageData = (row: any) => {
  if (!row) return
  row._pageData = createChildPageData(row)
  row._hideChildPagination = false
}

/** 批量初始化订单列表的商品子表分页参数。 */
const resetChildPageDataList = (data: any) => {
  if (!Array.isArray(data)) return
  data.forEach(resetChildPageData)
}

export default () => {
  const STableRef = ref()
  const SChildTableRefs: Ref<any[]> = ref([])
  const pageData = ref({
    page: 1,
    limit: 10
  })
  // 每页勾选情况
  const selectPageOption: any = ref({})
  watch(pageData, (newValue: any, oldValue) => {
    if (oldValue.limit !== newValue.limit) {
      selectPageOption.value = {}
    }
  })

  const changeSelectFn = (data: any) => {
    const ids = (selectPageOption.value[pageData.value.page] && selectPageOption.value[pageData.value.page].map((item: any) => item.platformOrderId)) || []
    nextTick(() => {
      data.forEach((item: any) => {
        if (ids.indexOf(item.platformOrderId) > -1) {
          STableRef.value.toggleRowSelection(item)
        }
      })
    })
  }

  const refreshTable = (type?: boolean) => {
    if (type) {
      pageData.value = {
        page: 1,
        limit: 30
      }
    }
    selectPageOption.value = {}
    nextTick(() => {
      STableRef.value && STableRef.value.getData()
    })
  }
  const expandList: any = ref([])
  const handleExpandRow = (val: any, flag: boolean) => {
    if (flag) {
      expandList.value.push(val.platformOrderId)
      resetChildPageData(val)
      nextTick(() => {
        SChildTableRefs.value[val.platformOrderId].getData()
      })
    } else {
      const idx = expandList.value.findIndex((e: any) => e === val.platformOrderId)
      expandList.value.splice(idx, 1)
    }
  }
  const handleExpandAll = (val: any, flag: boolean) => {
    if (flag) {
      expandList.value = val
      for (const el of val) {
        nextTick(() => {
          SChildTableRefs.value[el].getData()
        })
      }
    } else {
      expandList.value = []
    }
  }

  const toggleExpandAllChange = (val: any) => {
    nextTick(() => {
      SChildTableRefs.value[val.platformOrderId].expandAllChange()
    })
  }
  // 当前页勾选
  const selectedOrderList: any = ref([])
  // 勾选
  const handleSelectionChange = (val: any) => {
    selectPageOption.value[pageData.value.page] = val
    selectedOrderList.value = val
  }

  return {
    STableRef,
    pageData,
    refreshTable,
    SChildTableRefs,
    handleExpandRow,
    handleExpandAll,
    selectedOrderList,
    expandList,
    handleSelectionChange,
    toggleExpandAllChange,
    changeSelectFn,
    selectPageOption,
    resetChildPageDataList
  }
}
